import { useCallback } from "react";
import { DashboardGroupParam } from "@data-root/types";
import { Button, Form, Input, Layout, Popover } from "antd";
import { DownOutlined, SaveOutlined } from "@ant-design/icons";
import { useAppContext, useDashboardPanelContext } from "@data-root/react";

const { Content } = Layout;

export const ParamButton = ({ param }: { param: DashboardGroupParam }) => {
  const { getView } = useAppContext();

  const { layout, setParam } = useDashboardPanelContext();

  const { tableId } = getView(layout.viewId);

  const onFinish = useCallback(
    ({ value }: { value: string }) => {
      setParam(tableId, param.id, value, value);
    },
    [setParam, param.id, tableId]
  );

  return (
    <Popover
      content={
        <Layout>
          <Content>
            <Form
              layout="vertical"
              name="Edit Param"
              onFinish={onFinish}
              initialValues={{ value: param.value }}
            >
              <Form.Item label="Value" name="value">
                <Input />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                >
                  Save
                </Button>
              </Form.Item>
            </Form>
          </Content>
        </Layout>
      }
    >
      <Button size="small" icon={<DownOutlined />} iconPosition="end">
        {param.name}
      </Button>
    </Popover>
  );
};
